import React from 'react';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { CurrencyLockTypeEnum } from '@api/ringil-api.v2';
import useTranslationLgs from '@hooks/i18n/useTranslation';

interface InputCurrencyLockProps {
  value: CurrencyLockTypeEnum;
  onChange: (value: CurrencyLockTypeEnum) => void;
  required?: boolean;
}

export const InputCurrencyLock: React.FC<InputCurrencyLockProps> = ({
                                                                      value,
                                                                      onChange,
                                                                      required = true,
                                                                    }) => {
  const { tr } = useTranslationLgs();

  const currencyLockTypeOptions = Object.values(CurrencyLockTypeEnum).map(value => ({
    value,
    label: value === CurrencyLockTypeEnum.NONE
      ? tr('InputCurrencyLock.typeEnumNone', 'Without limitations')
      : tr('InputCurrencyLock.typeEnumOnlySelected', 'Only selected'),
  }));

  const initialCurrencyLockType = CurrencyLockTypeEnum.NONE;

  return (
      <Dropdown
        className="text-content-secondary font-dm-sans text-[14px] font-normal flex-[1_0_auto] max-w-[177px] text-center overflow-hidden text-ellipsis whitespace-nowrap"
        options={currencyLockTypeOptions}
        optionValue="value"
        optionLabel="label"
        value={value || initialCurrencyLockType}
        onChange={(e) => onChange(e.value)}
      />
  );
};